// The "+ N more" toggle under a device's or an identity's findings when only the first few are listed
// (Security Operations). N counts what the "Most exposed" card counts - open findings still naming the
// object, one per risk - so the card's total and the shown rows add up. The list itself also carries
// closed findings, links no longer named and a second link to the same risk; when none of the hidden
// rows is a further open finding, the toggle offers the whole list instead.
export function moreFindingsLabel(findings, shown) {
  const openRisks = (rows) => new Set(rows.filter((f) => f.isActive && f.isOpen).map((f) => f.unifiedRiskId));
  const shownRisks = openRisks(shown);
  const more = [...openRisks(findings)].filter((id) => !shownRisks.has(id)).length;
  return more > 0
    ? `+ ${more} more finding${more === 1 ? "" : "s"}`
    : `Show all ${findings.length} findings`;
}
